export const mobilePayment = {
  mobilePaymentBank: "Bank",
  mobilePaymentPhone: "Phone",
  mobilePaymentAction: "Action",
  mobilePaymentEdit: "Edit",
  mobilePaymentDelete: "Delete",
  mobilePaymentDeleteConfirm: "Are you sure you want to delete mobile payment account?",
  mobilePaymentDeleteYes: "Yes",
  mobilePaymentDeleteNo: "No",

  mobilePaymentTitle: "Mobile payment",
  mobilePaymentAdd: "Add Mobile Payment",
  mobilePaymentBtnAdd: "Add",
  mobilePaymentBtnBack: "Back",

  mobilePaymentEditTitle: "Edit Mobile Payment Account",

  mobilePaymentModalBank: "Bank",
  mobilePaymentModalPhone: "Phone",
  mobilePaymentModalSelectBank: "Select Bank",
  mobilePaymentModalSelectBankMessage: "Please select a bank",
  mobilePaymentModalPhonePlaceholder: "Phone",
  mobilePaymentModalPhonePlaceholderMessage: "Please enter your phone number",
  mobilePaymentModalSubmitBtn: "Accept",

  // New registration modal translations
  pagoMovilRegistrationTitle: "Mobile Payment Registration Required",
  pagoMovilRegistrationMessage:
    "To make deposits or withdrawals with Mobile Payment, you need to register your ID and phone number.",
  pagoMovilRegistrationCedula: "Identity Card",
  pagoMovilRegistrationCedulaPlaceholder: "Enter your ID number",
  pagoMovilRegistrationCedulaMessage: "Please enter your identity card number",
  pagoMovilRegistrationCedulaValidation: "Only numbers are allowed",
  pagoMovilRegistrationCedulaMinLength: "ID card must have at least 7 digits",
  pagoMovilRegistrationCedulaMaxLength: "ID card cannot have more than 15 digits",
  pagoMovilRegistrationPhoneNumber: "Phone Number",
  pagoMovilRegistrationPhoneNumberPlaceholder: "Enter your phone number",
  pagoMovilRegistrationPhoneNumberMessage: "Please enter your phone number",
  pagoMovilRegistrationPhoneValidation: "Please enter a valid phone number",
  pagoMovilRegistrationPhoneMinLength: "Phone number must have at least 10 digits",
  pagoMovilRegistrationSubmitBtn: "Register",
  pagoMovilRegistrationCancelBtn: "Cancel",
  pagoMovilRegistrationSuccessTitle: "Data registered successfully",
  pagoMovilRegistrationSuccessMessage: "Your ID and phone number have been registered successfully.",
  pagoMovilRegistrationErrorTitle: "Error registering data",
  pagoMovilRegistrationErrorMessage: "There was an error trying to register your information. Please try again.",

  // Pago Movil account creation error translations
  pagoMovilCreationErrorTitle: "Error adding account",
  pagoMovilCreationErrorMessage: "Could not add the mobile payment account. Please try again.",

  // AddPagoMovil form translations
  addPagoMovilExplanationTitle: "We just need a few details",
  addPagoMovilExplanationMessage:
    "We need this info just once so your deposits and withdrawals go through smoothly. It's quick.",
  registerAndAddPagoMovil: "Register & Add Mobile Payment",

  // Basic field names
  name: "Name",
  lastName: "Last Name",
  nationalID: "National ID",
  phoneNumber: "Phone Number",
  nameRequired: "Name is required",
  lastNameRequired: "Last name is required",
  nationalIDRequired: "National ID is required",
  phoneNumberRequired: "Phone number is required",
  phoneNumberMinLength: "Phone number must have at least 10 digits",
  phoneNumberMaxLength: "Phone number cannot have more than 11 digits",

  // Confirmation overlay translations
  confirmSaveChanges: "Are you sure you want to save the changes?",
  accept: "Accept",
  cancel: "Cancel",

  // Delete confirmation modal translations
  deleteConfirmationTitle: "Delete Mobile Payment Account",
  deleteConfirmationMessage: "You are about to delete one of your mobile payment accounts",
  deleteConfirmationBank: "Bank",
  deleteConfirmationPhone: "Phone",

  // Email verification translations
  registrationEmailVerificationTitle: "Email Verification",
  registrationEmailVerificationMessage:
    "A verification link has been sent to your email address. Please check your inbox and click the link to continue.",
};
